<div class="template-detail-container">
  <nz-spin *ngIf="loading && !error" [nzSpinning]="true" nzTip="Carregando formulário...">
    <div style="min-height: 200px;"></div>
  </nz-spin>

  <nz-result
    *ngIf="error"
    nzStatus="error"
    nzTitle="Erro ao Carregar Template"
    [nzSubTitle]="errorMessage">
  </nz-result>

  <div class="template-detail-canvas" *ngIf="!loading && !error">
    <app-builder-canvas-beta [viewMode]="'view'"></app-builder-canvas-beta>
  </div>
</div>
